<template>
  <modal-template>
    <template #header>
      <div class="modal-header-style">
        <div style="float:left;padding-left:1%;padding-top:1%;font-weight:bold;font-size:larger;font-style:italic;">
          <span>send message to dairy</span>
        </div>
        <div style="float:right;">
          <label class="action-icon-style" v-on:click="$emit('close', true)">
            <font-awesome-icon icon="xmark" size="xl"/>
            <span style="display: block;">close</span>
          </label>
        </div>
      </div>
      <div style="width:100%;float:left;color:black;border-bottom:1px solid black;">
        <div style="width:80%;float:left;">
          <span style="font-size:larger;font-weight:bold;">
            <sup>[{{ account.dairyId }}]</sup> {{ account.dairyName }}
          </span>
        </div>
        <div style="width:15%;float:left;text-align:center;">
        </div>
      </div>
    </template>
    <template #body>
      <div style="font-style:italic;font-weight:bold;">
        <span>your message:</span>
      </div>
      <div>
          <textarea v-model="message" style="width:600px;height:150px;"/>
      </div>
    </template>
    <template #footer>
      <div style="min-height:40px;width:100%;float:left;text-align:right;">
        <button v-if="message" type="button" v-on:click="send">send</button>
      </div>
    </template>
  </modal-template>
</template>

<script>
import ModalTemplate from '@/components/ModalTemplate'

export default {
  name: 'EmailPOC',
  props: ['account', 'username'],
  emits: ['close', 'apierroor', 'apierrortext'],
  data: function () {
    return {
      message: '',
    }
  },
  methods: {
    send: function () {
      let assignee = {}
      assignee.dairyId = this.account.dairyId
      assignee.dairyName = this.account.dairyName
      assignee.customerId = this.account.customerId
      assignee.customerName = this.account.customerName
      assignee.user = this.username

      this.axios
          .post('user/emailDairy', {
            assignee: assignee,
            message: this.message
          })
          .then(() => {
          })
          .catch(error => {
            this.setApiError(true)
            this.setApiErrorText(error.response.statusText)
          })
          .finally(() => {
            this.$emit('close', true)
          })
    },
  },
  components: {
    ModalTemplate,
  },
}
</script>

<style scoped>
.modal-header-style {
  width: 100%;
  float: left;
  background: black;
  color: white;
  border-radius: 4px;
}

.action-icon-style {
  color: white;
  text-align: center;
  cursor: pointer;
  width: 80px;
}

.action-icon-style:hover {
  font-weight: bolder;
}
</style>
